import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getCustomFiltersSettingsUrl } from '../../common/urls/index.tsx';
import type { CardId, PartialCard } from '../../model/types.tsx';
import { openDetailView } from '../../state/actions/detail-view/index.tsx';
import { getRapidViewId, getProjectKey } from '../../state/selectors/app/index.tsx';
import { partialCardsFromCardIdsSelector } from '../../state/selectors/cards/index.tsx';
import { canEditBoardConfig } from '../../state/selectors/permissions/index.tsx';
import type { State } from '../../state/types.tsx';
import CardCreateFiltered, { type Props } from './view.tsx';

const getActiveCustomFilterIds = (state: State): string[] => state.ui.filters.CUSTOM_FILTER || [];
const isCustomFiltersActive = (state: State) => getActiveCustomFilterIds(state).length > 0;

type OwnProps = {
	cardIds: CardId[];
	id: string | number;
	onDismissed: undefined | ((arg1: string | number) => void);
};

type StateProps = {
	showCustomFiltersSettingsLink: boolean;
	cards: PartialCard[];
	customFiltersSettingsUrl: string;
};

type DispatchProps = {
	onViewIssue: (cardId: CardId) => void;
};

const mapStateToProps = (state: State, { cardIds }: OwnProps): StateProps => ({
	cards: partialCardsFromCardIdsSelector(state)(cardIds),
	showCustomFiltersSettingsLink: canEditBoardConfig(state) && isCustomFiltersActive(state),
	customFiltersSettingsUrl: getCustomFiltersSettingsUrl(
		getProjectKey(state),
		getRapidViewId(state),
	),
});

const mapDispatchToProps = {
	onViewIssue: openDetailView,
} as const;

export const mergeProps = (
	stateProps: StateProps,
	dispatchProps: DispatchProps,
	{ id, onDismissed }: OwnProps,
): Props => ({
	id,
	onDismissed,
	...stateProps,
	...dispatchProps,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CardCreateFiltered);
